import { RouteConfig } from 'vue-router'
import { analyticsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const Analytics = () =>
  import(
    /* webpackChunkName: "domain-settings" */ '@/pmd/pages/analytics/FunnelWebsiteAnalytics.vue'
  ).then(m => m.default)

export const analyticsRoute: RouteConfig[] = [
  {
    path: 'analytics',
    name: analyticsRouteNames.default,
    component: Analytics,
    beforeEnter: requireAuthAndLocation,
  },
]
